import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	basicModeDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	basicModeOverflowMenu: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	advancedModeOverflowMenu: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	basicModeDisabledTooltip: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-disabled-tooltip',
		defaultMessage: "You can't switch to basic as the query is too complex or is invalid",
		description:
			'Tooltip content to display when a the switch to the basic mode button is disabled.',
	},
	basicModeOverflowMenu: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-overflow-menu',
		defaultMessage: 'Switch to Basic',
		description: 'Button text to display when a user can switch to the basic search mode.',
	},
	advancedModeOverflowMenu: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.advanced-mode-overflow-menu',
		defaultMessage: 'Switch to JQL',
		description: 'Button text to display when a user can switch to the advanced search mode.',
	},
});
